import actions from '../../actionTypes';

export default (tags, startDate = new Date(), endDate = new Date()) => {
  return {
    type: actions.CSV_HISTORY,
    startDate,
    endDate,
    tags
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/downloadCSVHistory.js